import React from "react";
import { shape, arrayOf, object, string } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { ComponentsSliderFluid } from "./ComponentsSliderFluid";

const ComponentsSliderConnector = ({ data, locale }) => {
	const getValue = i => {
		switch (i) {
			case "yes":
				return true;
			case "no":
				return false;
			default:
				return i;
		}
	};
	return (
		<ComponentsSliderFluid
			slides={data.slides}
			locale={locale}
			slidesPerPage={data.slidesPerPage}
			variant={data.variant}
			showArrowButtons={data.showArrowButtons}
			paging={getValue(data.paging)}
			navigation={getValue(data.navigation)}
			id={data.id}
		/>
	);
};

ComponentsSliderConnector.propTypes = {
	data: shape({
		slides: arrayOf(object),
	}).isRequired,
	locale: string,
};

ComponentsSliderConnector.defaultProps = {
	locale: null,
};

export default ComponentsSliderConnector;
export { ComponentsSliderConnector };
